// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__38CDe","addWidgetButton":"Header_addWidgetButton___9SCr","dashboardTabs":"Header_dashboardTabs__3lPbA","active":"Header_active__2bNlf"};